<div class="container-fluid py-3">
  <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
    <h4 class="mb-0">Identity Security</h4>
    @if (customerState() === 'ready' && dataSync(); as sync) {
      <span class="text-muted small" [title]="sync.last_synced_at">
        {{ sync.source }} data last updated {{ sync.last_synced_at | date: 'MMM d, y, h:mm a' }}
      </span>
    }
  </div>

  @switch (customerState()) {
    @case ('missing-integration') {
      <app-itdr-missing-integration [missing]="dataSync()!.missing_integrations" />
    }
    @case ('first-sync') {
      <app-itdr-first-sync />
    }
    @case ('ready') {
      <app-page-tabs
        [tabs]="tabs"
        [activeTab]="activeTab()"
        (tabChange)="onTabChange($event)"
      ></app-page-tabs>

      <div class="mt-3">
        @switch (activeTab()) {
          @case ('dashboard') {
            <app-itdr-dashboard [organizationId]="organizationId()" />
          }
          @case ('posture') {
            <app-itdr-posture [targetCheckId]="targetCheckId()" [organizationId]="organizationId()" />
          }
        }
      </div>
    }
  }
</div>
